import {STUDY_DEFINITIONS} from './study-definitions.mjs'
import {SMOOTHED_TYPES} from './indicator-contracts.mjs'
const COLORS = ['#2962ff', '#ef5350', '#26a69a', '#ab47bc']
export function indicatorPlots(ov) {
    const settings = ov.settings || {}
    const configured = settings.$plotConfig || settings.plotConfig
    if(ov.type==='Crossover'&&configured?.outputs?.length===3)return [configured.outputs[2],configured.outputs[0]].map((plot,index)=>({...plot,label:index?'Slow MA':'Fast MA'}));
    if (configured && configured.outputs && configured.outputs.length && !SMOOTHED_TYPES.has(ov.type) && !['NVI','PVI','VWAP'].includes(ov.type)) return configured.outputs
    const named = STUDY_DEFINITIONS[ov.type]?.outputs || {
        ENV:['Upper','Basis','Lower'],PVO:['PVO','Signal','Histogram'],ADX:['ADX'],AroonOscillator:['Aroon oscillator'],CoppockCurve:['Coppock curve'],PVT:['PVT'],
        MACD: ['Histogram', 'MACD', 'Signal'], Stoch: ['K', 'D'], StochasticRSI: ['K', 'D'],
        DMI: ['ADX', '+DI', '−DI'], Aroon: ['Up', 'Down', 'Oscillator'], Vortex: ['VI+', 'VI−'],
        TRIX: ['TRIX', 'Signal'], TSI: ['TSI', 'Signal'], KST: ['KST', 'Signal'],
        QQE: ['Smoothed RSI', 'Trailing band', 'Short band', 'Long band'],
        Ichi: ['Cloud span A', 'Cloud span B'], PivotPoints: ['Pivot', 'R1', 'R2', 'R3', 'S1', 'S2', 'S3', 'R4', 'S4', 'R5', 'S5'],
        BB: ['Upper', 'Middle', 'Lower'], DC: ['Upper', 'Middle', 'Lower'],
        KC: ['Upper', 'Middle', 'Lower'], LinReg: ['Upper', 'Middle', 'Lower'],
        Volume:['Volume','Volume MA'],
        NVI:['Negative Volume Index','EMA'], PVI:['Positive Volume Index','EMA'], SupportResistanceTable:['Support','Resistance'],
        VWAP:['VWAP','Upper band 1','Lower band 1','Upper band 2','Lower band 2','Upper band 3','Lower band 3'],
        Crossover:['Fast MA','Slow MA'],
        SuperTrend:['Supertrend'],FisherTransform:['Fisher','Trigger'],
        SAR: ['SAR'], PPO: ['PPO', 'Signal'], ElderRay: ['Bull power', 'Bear power'],
    }[ov.type]
    if(SMOOTHED_TYPES.has(ov.type))return [ov.type,'Smoothing MA','Smoothing BB upper','Smoothing BB lower'].map((label,i)=>({key:i?'plot'+i:'main',label,color:i===0?(settings.color||COLORS[0]):i===1?'#ffb300':'#26a69a',width:settings.lineWidth??1.5,style:'line',visible:true,...configured?.outputs?.[i]}));
    const row = (ov.data || []).find(row => row.length > 1)
    const count = named ? named.length : row ? row.length - 1 : 1
    const keys = { MACD:['defColor','macdColor','signalColor'], Stoch:['kColor','dColor'], BB:['topColor','color','bottomColor'], DC:['topColor','color','bottomColor'], KC:['topColor','color','bottomColor'] }[ov.type] || []
    return Array.from({length: count}, (_, i) => ({
        key: count === 1 ? 'main' : `plot${i}`, label: named ? named[i] : count === 1 ? ov.type : `Plot ${i + 1}`,
        color: settings[keys[i]] || (settings.colors || [])[i] || (i === 0 && settings.color) || COLORS[i % COLORS.length],
        width: (settings.lineWidths || [])[i] || settings.lineWidth || 1.5,
        ...configured?.outputs?.[i],
        style: configured?.outputs?.[i]?.style || settings.lineStyle || STUDY_DEFINITIONS[ov.type]?.style || (ov.type === 'SAR' ? 'dots' : ov.type==='PVO'&&i===2 || ov.type === 'Volume' || ov.type === 'AcceleratorOscillator' || ov.type === 'AwesomeOscillator' || ov.type === 'MACD' && i === 0 ? 'histogram' : 'line'),
    }))
}

// Shared finite-value plotting keeps warm-up gaps out of the canvas path.
export function drawIndicatorPlot(ctx, data, layout, settings, index, defaults = {}) {
    const plot = settings.$plotConfig && settings.$plotConfig.outputs && settings.$plotConfig.outputs[index] || {}
    if(plot.visible===false)return
    const style = plot.style || settings.lineStyle || defaults.style || 'line'
    ctx.save()
    ctx.strokeStyle = ctx.fillStyle = plot.color || defaults.color || settings.color || COLORS[index % COLORS.length]
    ctx.lineWidth = plot.width || defaults.width || settings.lineWidth || 1.5
    const opacity = settings.$opacities && settings.$opacities[index] != null ? settings.$opacities[index] : settings.opacity
    ctx.globalAlpha = opacity == null ? 1 : opacity / 100
    ctx.setLineDash(style === 'dashed' ? [6,4] : style === 'dotted' ? [2,3] : [])
    ctx.beginPath()
    let connected = false
    let previousPoint=null
    for (let rowIndex=0;rowIndex<data.length;rowIndex++) {
        const row=data[rowIndex]
        const value = row[index + 1]
        if (!Number.isFinite(value)) { connected = false; continue }
        const x = layout.t2screen(row[0]), y = layout.$2screen(value)
        if (!Number.isFinite(x) || !Number.isFinite(y)) { connected = false; continue }
        if (style === 'dots') { ctx.moveTo(x + ctx.lineWidth, y); ctx.arc(x, y, ctx.lineWidth, 0, Math.PI * 2) }
        else if (style === 'histogram') {
            if(defaults.colorForRow){ctx.beginPath();ctx.strokeStyle=defaults.colorForRow(row);}
            ctx.moveTo(x, layout.$2screen(0)); ctx.lineTo(x, y);
            if(defaults.colorForRow)ctx.stroke();
        }
        else {
            if(defaults.colorForRow){
                if(connected&&previousPoint){ctx.beginPath();ctx.strokeStyle=defaults.colorForRow(row,data[rowIndex-1]);ctx.moveTo(...previousPoint);ctx.lineTo(x,y);ctx.stroke();}
                previousPoint=[x,y];
            }else if (!connected) ctx.moveTo(x,y); else ctx.lineTo(x,y);
            connected = true;
        }
    }
    if (style === 'dots') ctx.fill(); else if(!defaults.colorForRow)ctx.stroke()
    ctx.restore()
}

export function drawSmoothingPlots(ctx,data,layout,settings) {
    if(!settings.smoothing || settings.smoothing==='None')return;
    drawIndicatorPlot(ctx,data,layout,settings,1,{color:'#ffb300'});
    if(settings.smoothing==='SMA + Bollinger Bands'){
        drawIndicatorPlot(ctx,data,layout,settings,2,{color:'#26a69a'});
        drawIndicatorPlot(ctx,data,layout,settings,3,{color:'#26a69a'});
    }
}
export function drawOscillatorBands(ctx,layout,settings) {
    ctx.save();
    const upper=layout.$2screen(settings.upper),lower=layout.$2screen(settings.lower);
    if(settings.showBackground!==false && Number.isFinite(upper)&&Number.isFinite(lower)){
        ctx.fillStyle=settings.backColor||'#7e57c21a';ctx.fillRect(0,Math.min(upper,lower),layout.width,Math.abs(lower-upper));
    }
    ctx.strokeStyle=settings.bandColor||'#787b86';ctx.lineWidth=settings.bandWidth??1;ctx.setLineDash([4,4]);
    for(const [key,toggle] of [['upper','showUpper'],['middle','showMiddle'],['lower','showLower']]){
        const y=layout.$2screen(settings[key]);if(settings[toggle]===false||!Number.isFinite(y))continue;
        ctx.beginPath();ctx.moveTo(0,y);ctx.lineTo(layout.width,y);ctx.stroke();
    }
    ctx.restore();
}
